export const INSURED_DETAILS = 'INSURED_DETAILS';
export const VIN_VALIDATION = 'VIN_VALIDATION';
export const VEHICLE_DETAILS = 'VEHICLE_DETAILS';
export const VEHICLE_STAKEHOLDERS_DETAILS = 'VEHICLE_STAKEHOLDERS_DETAILS';
export const INSURED_STAKEHOLDERS_DETAILS = 'INSURED_STAKEHOLDERS_DETAILS';
export const SUBMIT = 'SUBMIT';
